// Components
const BreederDetailsComponent = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: 'breeder-details-component' */ "@/app/views/main-view/breeders/components/breeder-details-component/breeder-details-component.vue"
    );

export default {
    name: "BreederDetailsContainer",
    components: { BreederDetailsComponent },
};
